export enum EnumMaster {
  /** 進出口別 */
  declType = 'declType',
  /** 記帳代號 */
  chkCode1 = 'chkCode1',
  /** 業者名稱 */
  expressCnName = 'expressCnName',
  /** 快遞倉站 */
  warehouse = 'warehouse',
  /** 主號 */
  mawbNo = 'mawbNo',
  /** 分號 */
  hawbNo = 'hawbNo',
  /** 開始日期 */
  startDate = 'startDate',
  /** 結束日期 */
  endDate = 'endDate',
  /** 開始時間 */
  startTime = 'startTime',
  /** 結束時間 */
  endTime = 'endTime',
  /** 是否加入時間查詢 */
  timeCheck = 'timeCheck',
  /** 報單號碼 */
  declNo = 'declNo',
  /** 報單類別 */
  appType = 'appType',
  endDateValid = 'endDateValid',
  endTimeValid = 'endTimeValid',
  startDateValid = 'startDateValid',
  startTimeValid = 'startTimeValid',
}
export enum EnumColumnData {
  headerName = 'headerName',
  field = 'field',
}
